import { Avatar as ChakraAvatar } from '@chakra-ui/react';
import { SystemProps, ThemingProps } from './primitives.types';

export interface AvatarProps extends SystemProps, ThemingProps, Omit<React.ComponentPropsWithoutRef<'span'>, keyof SystemProps | 'onError'> {
  name?: string;
  src?: string | null;
}

export function Avatar({
  name,
  src,
  size = 'sm',
  borderRadius = 4,
  ...props
}: AvatarProps) {
  return (
    <ChakraAvatar
      size={size}
      borderRadius={borderRadius}
      name={name ?? '?'}
      src={src ?? undefined}
      {...props}
    />
  );
}